import { createContext, useContext } from 'react';

import { PhoneFieldContext } from './hooks/use-phone-field.provider';

export const ComponentContext = createContext<PhoneFieldContext | null>(null);

export function usePhoneFieldContext() {
  const contextValue = useContext(ComponentContext);
  if (!contextValue) {
    throw new Error('usePhoneFieldContext must be used within a PhoneFieldProvider');
  }
  return contextValue;
}
